import { render } from "./Lead_Tasks.vue?vue&type=template&id=21b045f6"
import script from "./Lead_Tasks.vue?vue&type=script&lang=js"
export * from "./Lead_Tasks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__